import { DateTime } from 'luxon'
import { useMemo } from 'react'

export const useNow = () => useMemo(() => DateTime.now(), [])
